var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',[_c('div',{staticClass:"page-footer-wrapper"},[_c('div',{staticClass:"page-footer"},[_c('div',{staticClass:"page-footer-content"},[_c('div',{staticClass:"page-footer-select col-xs-6 col-sm-6 col-md-6",style:('left: 0')}),_vm._v(" "),_c('div',{staticClass:"page-footer-option col-xs-6 col-sm-6 col-md-6"})])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }